import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstituteSubmissionDetailPage } from '@/features/instituteSubmissions/pages/InstituteSubmissionDetailPage';

export const Route = createFileRoute('/_auth/settings/institute-submissions/$submissionId')({
  parseParams: ({ submissionId }) => {
    const parsedId = Number(submissionId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { submissionId: parsedId };
  },
  component: function InstituteSubmissionDetailRoute() {
    const { submissionId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Institute Submission">
        <Suspense fallback={<PageLoader />}>
          <InstituteSubmissionDetailPage submissionId={submissionId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
